<script>
import VDescriptionList from '.';

export default {
  name: 'DescriptionListCols',

  functional: true,

  render: (h, { children }) => {
    children = children.filter(c => c.tag);
    if (children.length === 0) return;
    if (children.length < 5) return h(VDescriptionList, children);
    const half = Math.ceil(children.length / 4) * 2;
    return h('div', { staticClass: 'row' }, [
      h('div', { staticClass: 'col-l-6 col-m-12' }, [h(VDescriptionList, { staticClass: 'bottom-line-m' }, children.slice(0, half))]),
      h('div', { staticClass: 'col-l-6 col-m-12' }, [h(VDescriptionList, {}, children.slice(half))]),
    ]);
  },
};
</script>
